import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useTrail, animated } from 'react-spring';
import { useBusinessCard } from './BusinessCard';
import firebase from 'firebase/app';
import 'firebase/storage';
import styled from 'styled-components';
import { Dialog } from '@reach/dialog';
import '@reach/dialog/styles.css';
import PurchaseButtons from './PurchaseButtons';

const wai = '/images/social/wai-message.png';

const Container = styled.div`
  padding: 0rem 0.5rem;
  width: ${(p) => p.theme.dimensions.width}px;
`;
const config = { mass: 10, tension: 2000, friction: 200 };

export async function getProductImage(image) {
  if (typeof image === 'string') {
    return await firebase.storage().ref(image).getDownloadURL();
  }
  if (image && typeof image === 'object') {
    return URL.createObjectURL(image);
  }
  return null;
}

const SecondaryProductsContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: row;
  margin-top: 1rem;
  grid-template-columns: 0.6fr 0.2fr;
  column-gap: 1rem;
  align-content: center;
  justify-content: center;
  justify-items: stretch;
`;

const GridContainer = styled.div`
  width: 100%;
  column-gap: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1rem;
  align-content: center;
  justify-content: stretch;
  justify-items: stretch;
  padding-bottom: 4rem;
`;

const ProductsList = ({onPurchase,addToCart}) => {
  const [ready, setReady] = useState(false);
  const [open, setOpen] = useState(false);
  const toggle = () => {
    if (open) {
      setFirstImage(modalProduct?.image)
      setSecondImage(modalProduct?.image2)
      setThirdImage(modalProduct?.image3)
    }
    setOpen(!open);
  }
  const [modalProduct, setModalProduct] = useState(null);
  const [productsWithImages, setProductsWithImages] = useState([]);

  const [firstImage, setFirstImage] = useState();
  const [secondImage, setSecondImage] = useState();
  const [thirdImage, setThirdImage] = useState();

  const instance = useBusinessCard();
  const {
    user,
    card: { products, backgroundColor, phoneNumber, waText = 'האם קיים במלאי המוצר: ' },
  } = instance;

  const sharePhoneNumber = '972' + phoneNumber?.slice(1);

  const { MAX_PRODUCTS } = useMemo(() => {
    const isPremium =
      user.plan === 'pro' || ['', 'business'].includes(user.role);
    return { MAX_PRODUCTS: isPremium ? 50 : 25, isPremium };
  }, [user.plan, user.role]);

  const _products = useMemo(() => {
    return !user.plan || !products
      ? undefined
      : products.slice(0, MAX_PRODUCTS);
  }, [products, user, MAX_PRODUCTS]);

  const fetchProductsImages = useCallback(async () => {
    if (!_products) {
      return [];
    }
    const promises = _products
      .filter((item) => !!item.image)
      .map(async (item) => {
        const image = await getProductImage(item.image);
        let image2 = null;
        let image3 = null;
        if (item.image2) {
          image2 = await getProductImage(item.image2);
        }
        if (item.image3) {
          image3 = await getProductImage(item.image3);
        }
        return { ...item, image, image2, image3 };
      });
    const res = await Promise.all(promises);
    return res;
  }, [_products]);

  useEffect(() => {
    setFirstImage(modalProduct?.image)
    setSecondImage(modalProduct?.image2)
    setThirdImage(modalProduct?.image3)
  }, [modalProduct]);


  useEffect(() => {
    fetchProductsImages().then((res) => {
      setProductsWithImages(res);
      setTimeout(() => {
        setReady(true);
      }, 500);
    });
  }, [setProductsWithImages, fetchProductsImages]);

  const [trail, set] = useTrail(productsWithImages.length, () => ({
    config,
    opacity: 0,

    from: { opacity: 0, x: 0, height: 0 },
  }));

  useEffect(() => {
    if (ready) {
      set({ opacity: 1 });
    }
  }, [set, ready]);

  if (!products?.length) {
    return null;
  }
  const shareTextForProduct = (product) => `${waText} ${product?.title}`;
  // const shareTextForProduct = (product) => `
  // רוצה לרכוש את המוצר: ${product?.title}
  // האם קיים במלאי?
  // תודה`;
  return (
    <>
      <Container>
        <GridContainer>
          {trail.map(({ x, height, ...rest }, index) => {
            const item = productsWithImages[index];
            return (
              <animated.div key={item.title}>
                <ProductImgContainer
                  borderColor={backgroundColor}
                  onClick={() => {
                    setModalProduct(item);
                    toggle();
                  }}
                >
                  <Badge
                    href={`https://wa.me/${sharePhoneNumber}?text=${shareTextForProduct(
                      item,
                    )}`}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <BadgeImage src={wai} />
                  </Badge>
                  <ContactMeTitle
                    href={`https://wa.me/${sharePhoneNumber}?text=${shareTextForProduct(
                      item,
                    )}`}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    שלחו הודעה
                  </ContactMeTitle>
                  <ProductImg
                    src={item.image}
                    alt={`${item.title} - ${item.description}`}
                  />

                  <ProductTitle>{item.title}</ProductTitle>
                </ProductImgContainer>
              </animated.div>
            );
          })}
        </GridContainer>
      </Container>
      <StyledDialog isOpen={open} onDismiss={toggle}>
        <LighboxContainer>
          <LightboxHeader onClick={toggle}> חזרה לקטלוג </LightboxHeader>
          <LightboxImage
            shareText={shareTextForProduct(modalProduct)}
            src={firstImage}
            title={modalProduct?.title}
            phoneNumber={sharePhoneNumber}
          />
          {secondImage && <SecondaryProductsContainer>
            <LightboxSmallImage
              shareText={shareTextForProduct(modalProduct)}
              src={secondImage}
              title={modalProduct?.title}
              phoneNumber={sharePhoneNumber}
              onClick={() => {
                setSecondImage(firstImage)
                setFirstImage(secondImage)
              }}
            />
            {thirdImage &&
            <LightboxSmallImage
              shareText={shareTextForProduct(modalProduct)}
              src={thirdImage}
              title={modalProduct?.title}
              phoneNumber={sharePhoneNumber}
              onClick={() => {
                setThirdImage(firstImage)
                setFirstImage(thirdImage)
              }}
            />}
          </SecondaryProductsContainer>}
          {modalProduct?.description && <LightboxDescription>
            פירוט המוצר: {modalProduct?.description}
          </LightboxDescription>}
          <div style={{display: 'flex',justifyContent:'center'}}>
          {modalProduct?.price && <LightboxPrice>{modalProduct?.price}</LightboxPrice>}
          {modalProduct?.price && <LightboxCart onClick={() => {
            addToCart(modalProduct)
            window.scrollTo(0, 0);
            toggle()
          }}>הוסף לסל</LightboxCart>}
          </div>          
          <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <PurchaseButtons item={modalProduct} size={10} onPurchase={onPurchase}/>
          </div>
        </LighboxContainer>
      </StyledDialog>
    </>
  );
};

const StyledDialog = styled(Dialog)`
  width: ${(p) => p.theme.dimensions.vw(90)}px;
  max-height: ${(p) => p.theme.dimensions.vh(90)}px;
  padding: 0.2rem;
  overflow-y: scroll;
`;
const LighboxContainer = styled.div`
  display: grid;
  grid-template-rows: 5rem 3fr fit-content auto;
  font-family: ${(p) => p.theme.font};
`;
const LightboxHeader = styled.span`
  cursor: pointer;
  grid-row: 1;
  padding: 0rem 1.75rem;
  height: 2rem;
`;
const LightboxDescription = styled.p`
  width: ${(p) => p.theme.dimensions.vw(75)}px;
  justify-self: center;
  margin: 0.5rem 0px;
`;
const LightboxPrice = styled.div`
  background-color: #111111;
  margin: 0.5rem;
  color: #f1f1f1;

  align-self: center;
  justify-self: center;
  padding: 1rem 3rem;
`;

const LightboxCart = styled.div`
  background-color: #111111;
  margin: 0.5rem;
  color: #f1f1f1;

  align-self: center;
  justify-self: center;
  padding: 1rem 3rem;
  cursor: pointer;
`;
const LightboxImage = ({ src, phoneNumber, title, shareText }) => {
  return (
    <LBImageContainer>
      <a
        href={`https://wa.me/${phoneNumber}?text=${shareText}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <LBWAI src="/images/social/wai.png" />
      </a>

      <LBContact
        href={`https://wa.me/${phoneNumber}?text=${shareText}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        שלחו לי שאלה בוואצפ
      </LBContact>
      <LBImage src={src} />
      <LBTitle>{title}</LBTitle>
    </LBImageContainer>
  );
};

const LightboxSmallImage = ({ src, phoneNumber, title, shareText }) => {
  return (
    <LBSmallImageContainer>
      <LBSmallImage src={src} />
      <LBTitle>{title}</LBTitle>
    </LBSmallImageContainer>
  );
};

const LBImageContainer = styled.div`
  align-self: center;
  justify-self: center;
  border: 2px solid #111111;
  padding: 0rem 0.5rem 0.5rem 0.5rem;
  display: grid;
  width: 75vw;
  grid-template-rows: 3rem auto 1rem;
  position: relative;
`;

const LBSmallImageContainer = styled.div`
  align-self: center;
  justify-self: center;
  border: 2px solid #111111;
  padding: 0rem 0.5rem 0.5rem 0.5rem;
  margin: 0rem 0.2rem 0.5rem 0.2rem;
  display: grid;
  width: 36vw;
  grid-template-rows: 3rem auto 1rem;
  position: relative;
`;

const LBTitle = styled.span`
  grid-row: 3;
  text-align: center;
`;
const LBContact = styled.a`
  font-size: 0.8rem;
  color: #111111;
  grid-row: 1;
  justify-self: end;
  margin-left: 1.5rem;
`;
const LBImage = styled.img`
  width: 70vw;
  height: auto;
  grid-row: 2;
  justify-self: center;
  align-self: center;
  object-fit: contain;
`;
const LBSmallImage = styled.img`
  width: 32vw;
  height: auto;
  grid-row: 2;
  justify-self: center;
  align-self: center;
  object-fit: contain;
`;
const LBWAI = styled.img`
  position: absolute;
  z-index: 50;
  top: -1.5rem;
  left: -1.5rem;
  width: 3rem;
  height: 3rem;
`;

const ContactMeTitle = styled.a`
  font-size: 0.9em;
  justify-self: start;
  text-align: right;
  margin-top: 0.5em;
  color: ${(p) => p.theme.textColor};
  width: 100%;
  grid-column: 2;
`;

const ProductTitle = styled.span`
  font-size: 1em;
  grid-column: 1/-1;

  color: ${(p) => p.theme.textColor};
`;

const BadgeImage = styled.div`
  background-image: url(${(p) => p.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 2.2em;
  height: 2.2em;
`;

const Badge = styled.a`
  outline: none;

  cursor: pointer;
  margin-top: -0.5em;
  margin-right: -0.5em;
`;

export default ProductsList;

const ProductImgContainer = styled.div`
  color: ${(p) => p.theme.textColor};
  border: 1px solid ${(p) => p.theme.textColor};
  display: grid;
  align-self: stretch;
  align-content: center;
  grid-template-columns: 2rem auto;
  grid-template-rows: 2rem auto 2rem;
  border-style: solid;
  justify-self: stretch !important;
  background-color: ${(p) => p.theme.rectangleColor};
`;

const ProductImg = styled.img`
  margin: 0 auto;
  grid-column: 1 / -1;
  width: calc(0.75 * (${(p) => p.theme.dimensions.vw(50)}px - 0.75rem));
  height: calc(0.75 * ${(p) => p.theme.dimensions.vh(30)}px);
  object-fit: contain;
`;
